import * as RadixPopover from "@radix-ui/react-popover";
import styles from "./style.module.css";

const Popover = ({ trigger, children, onOpen, onClose }) => {
  return (<RadixPopover.Root modal={true}>

    <RadixPopover.Trigger asChild className={styles.triggerWrapper}>
      <div data-testid="popover-trigger">{trigger}</div>
    </RadixPopover.Trigger>

    <RadixPopover.Portal>
      <RadixPopover.Content
        side="right"
        align="start"
        sideOffset={8}
        className={styles.casaPopoverContent}
        onCloseAutoFocus={() => { onClose && onClose() }}
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          onOpen && onOpen();
        }}
      >
        {children}
      </RadixPopover.Content>
    </RadixPopover.Portal>
  </RadixPopover.Root >)
};

export default Popover